module.exports = __webpack_public_path__ + "static/img/shushi-3.fedea8a6.png";